<template>
  <div class="home_page">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'orderList' }">订单列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="order_detail">
      <div class="detail_body">
        <div class="detail_row flex-between">
          <div class="top_title">订单详情</div>
          <div class="">状态：
            <font v-if="orderDetail" style="color: red;">{{$getDictLabel('ORDER_STATUS' ,orderDetail.orderStatus)}}</font>
          </div>
        </div>
        <div v-if="orderDetail">
          <div class="detail_row">
            <!-- 去支付 -->
            <div v-show="orderDetail.orderStatus == '20'">
              <el-button class="top_btn1"
                        @click="gotoPay"
                        type="primary"
                        style="margin-right:20px"
                        v-show="orderDetail.payStatus == '20' && orderDetail.paymentType != '60'"
                        >去支付</el-button>
              <el-button class="top-btn3"
                        type="primary"
                        style="margin-right:20px"
                        v-show="(orderDetail.payStatus == '20' || orderDetail.payStatus == '22' || orderDetail.payStatus == '24' || orderDetail.payStatus == '27') && orderDetail.paymentType == '60'"
                        @click="gotoPay"
                        >去支付</el-button>
            </div>
            <!-- 合同 -->
            <el-button class="top_btn2"
                      @click="contract"
                      type="primary"
                      v-show="orderDetail.contractType !== '30'">查看合同</el-button>
            <el-button class="top_btn1"
                      type="primary"
                      v-show="orderDetail.orderStatus === '12'"
                      @click="confirmOrderHandle">确认订单</el-button>
            <el-button class="top_btn2"
                      type="primary"
                      v-show="orderDetail.orderStatus === '12'"
                      @click="confirmPriceChangeHandle">申请改价</el-button>
            <el-button class="top_btn1"
                      type="primary"
                      v-show="orderDetail.orderSource === '45' &&orderDetail.orderStatus === '10'"
                      @click="confirmOrderBPMHandle">确认订单</el-button>
            <el-button class="top_btn1"
                      type="primary"
                      v-show="(orderDetail.orderSource !== '45'&&Number(orderDetail.orderStatusCode) || 29) < 29"
                      @click="cancelOrderHandle">取消订单</el-button>
          </div>
          <div class="detail_row flex-between">
            <div class="detail_row">
              <label class="flex-shrink">订单编号：</label>
              <div>{{orderDetail.orderCode}}</div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">用户名：</label>
              <div>{{orderDetail.userName}}</div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">订单来源：</label>
              <div>{{$getDictLabel('ORDER_SOURCE', orderDetail.orderSource)}}</div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">支付类型：</label>
              <div>默认以合同为准</div>
            </div>
          </div>
          <div class="detail_row flex-between">
            <div class="detail_row">
              <label class="flex-shrink">合同类型：</label>
              <div>
                {{$t('order.contractType.' + orderDetail.contractType)}}
                <!-- {{orderDetail.contractType === '10' ? '自定义合同' : orderDetail.contractType === '20' ? '默认合同' : '无需合同' }} -->
              </div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">合同状态：</label>
              <div>
                {{$getDictLabel("ORDER_CONTRACT_STATUS", orderDetail.contractStatus)}}
                <!-- {{$t('order.contractStatus.' + orderDetail.contractStatus)}} -->
              </div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">付款类型：</label>
              <div>
                {{orderDetail.fullAmount ? '全款发货' : '其他方式'}}
              </div>
            </div>
          </div>
          <div class="detail_row flex-between">
            <div class="detail_row">
              <label class="flex-shrink">采购公司：</label>
              <div>{{orderDetail.companyName}}</div>
            </div>
          </div>
          <div class="detail_row flex-between">
            订单商品：
          </div>
          <el-table ref="goodsTable"
                    :data="orderDetail.payOrderItemVoList.slice((goodsPage - 1) * 10, goodsPage * 10)"
                    style="width: 906px"
                    size="small"
                    border>
            <el-table-column type="index" width="50" align="center"></el-table-column>
            <el-table-column  prop="goodsCode"
                            label="商品编号"></el-table-column>
            <el-table-column prop="goodsName"
                            label="商品名称">
              <template slot-scope="scope">
                <span @click="goodDetail(scope.row)" class="cursor-pointer">{{scope.row.goodsName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="brandName"
                            label="品牌"></el-table-column>
            <el-table-column prop="goodsModel"
                            label="型号"
                            width="120">
              <template slot-scope="scope">
                <span @click="goodDetail(scope.row)" class="cursor-pointer">{{scope.row.goodsModel}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="goodsNum"
                            label="数量"
                            width="70"></el-table-column>
            <el-table-column label="折扣率"
                            width="70"
                            v-if="orderDetail.promotion !== 1">
              <template slot-scope="scope">
                <span :label="scope.row.discount">{{scope.row.discount}}%</span>
              </template>
            </el-table-column>
            <el-table-column label="单价"
                            width="130"
                            v-if="orderDetail.promotion !== 1">
              <template slot-scope="scope">
                <span :label="scope.row.goodsPrice"
                      class="discount">{{scope.row.goodsPrice}}</span><br />
                <span :label="scope.row.goodsPriceDiscount">{{scope.row.goodsPriceDiscount}}</span>
              </template>
            </el-table-column>
            <el-table-column label="单价"
                            width="130"
                            v-else>
              <template slot-scope="scope">
                <span :label="scope.row.goodsPrice">{{scope.row.goodsPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="logisticsTemplate"
                            label="运费规则"
                            width="130">
              <template slot-scope="scope">
                {{scope.row.logisticsTemplate}}
                <span class="deliveryArea" v-show="scope.row.distribution===1">不在配送区域</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="expressFee"
                            label="运费"
                            width="70"></el-table-column> -->
            <el-table-column label="总价"
                            width="130"
                            v-if="orderDetail.promotion !== 1">
              <template slot-scope="scope">
                <span :label="scope.row.money"
                      class="discount">{{scope.row.money}}</span><br />
                <span :label="scope.row.goodsMoney">{{scope.row.goodsMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column label="总价"
                            width="130"
                            v-else>
              <template slot-scope="scope">
                <span :label="scope.row.money">{{scope.row.money}}</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 商品分页 -->
          <el-pagination :current-page="goodsPage"
                          :page-size="10"
                          v-show="orderDetail.payOrderItemVoList && orderDetail.payOrderItemVoList.length > 10"
                          :total="orderDetail.payOrderItemVoList ? orderDetail.payOrderItemVoList.length : 0"
                          layout="total, prev, pager, next, jumper"
                          @current-change="changeGoodsPage">
          </el-pagination>
          <!-- 优惠，总金额 -->
          <el-row style="background-color:#ebebeb;">
            <el-col :span="5"
                    :offset="19"
                    style="margin-top:10px">
              <span>运费：<span style="color:red"><span>￥</span>{{orderDetail.expressFee || 0}}</span></span>
            </el-col>
          </el-row>
          <el-row style="background-color:#ebebeb; height:50px"
                  v-if="orderDetail.promotion !==1">
            <el-col :span="5"
                    :offset="14"
                    style="margin-top:10px">
              <span>折扣金额：<span style="color:#333"><span>￥</span>{{orderDetail.discountAmount}}</span></span>
            </el-col>
            <el-col :span="5"
                    :offset="0"
                    style="margin-top:10px">
              <span>总金额：<span style="color:red"><span>￥</span>{{orderDetail.payMoney}}</span></span>
            </el-col>
          </el-row>
          <el-row style="background-color:#ebebeb; height:50px" v-else>
            <el-col :span="5"
                    :offset="19"
                    style="margin-top:10px">
              <span>总金额：<span style="color:red"><span>￥</span>{{orderDetail.payMoney}}</span></span>
            </el-col>
          </el-row>
          <div class="detail_row flex-between">
            联系商家：{{orderDetail.contactPhone}}
          </div>
          <div class="detail_row flex-between">
            收货地址：
          </div>
          <el-table class="top_table"
                    :data="[orderDetail.payOrderAddressVo]"
                    :header-cell-style="{color:'#333333'}"
                    border>
            <el-table-column prop="receiveGoodsPerson"
                            label="收件人姓名"
                            width="150"
                            align="center">
            </el-table-column>
            <el-table-column prop="receiveGoodsPhone"
                            label="电话号码"
                            width="180"
                            align="center">
            </el-table-column>
            <el-table-column prop="orderAddress"
                            label="地址"
                            align="center">
            </el-table-column>
          </el-table>
          <!-- <div class="detail_row flex-between">
            <div class="detail_row flex-shrink item_col">
              <label class="flex-shrink">收件人姓名：</label>
              <div>{{orderDetail.payOrderAddressVo.receiveGoodsPerson}}</div>
            </div>
            <div class="detail_row flex-shrink item_col">
              <label class="flex-shrink">电话号码：</label>
              <div>{{orderDetail.payOrderAddressVo.receiveGoodsPhone}}</div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">地址：</label>
              <div class="">{{orderDetail.payOrderAddressVo.orderAddress}}</div>
            </div>
          </div> -->
          <!-- 发票 -->
          <!--  style="border-top: 1px solid #eee;" -->
          <div class="detail_row flex-between">
            <div class="detail_row item_col">
              <label class="flex-shrink">发票抬头：</label>
              <div>{{orderDetail.payOrderInvoiceVo ? orderDetail.payOrderInvoiceVo.companyName : ''}}</div>
            </div>
            <div class="detail_row item_col">
              <label class="flex-shrink">税务登记证号：</label>
              <div>{{orderDetail.payOrderInvoiceVo ? orderDetail.payOrderInvoiceVo.taxpayerIdentity : ''}}</div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">基本开户账号：</label>
              <div class="">{{orderDetail.payOrderInvoiceVo ? orderDetail.payOrderInvoiceVo.bankAccountNo : ''}}</div>
            </div>
          </div>
          <div class="detail_row flex-between">
            <div class="detail_row item_col">
              <label class="flex-shrink">发票类型：</label>
              <div>{{orderDetail.payOrderInvoiceVo ? (orderDetail.payOrderInvoiceVo.invoiceType ===  '10' ? '普通发票' : '专用发票') : ''}}</div>
            </div>
            <div class="detail_row item_col">
              <label class="flex-shrink">注册场所地址：</label>
              <div>{{orderDetail.payOrderInvoiceVo ? orderDetail.payOrderInvoiceVo.companyAddress : ''}}</div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">注册固定电话：</label>
              <div class="">{{orderDetail.payOrderInvoiceVo ? orderDetail.payOrderInvoiceVo.companyPhone : ''}}</div>
            </div>
          </div>
          <div class="detail_row flex-between">
            <div class="detail_row">
              <label class="flex-shrink">开户银行名称：</label>
              <div>{{orderDetail.payOrderInvoiceVo ? orderDetail.payOrderInvoiceVo.openingBank : ''}}</div>
            </div>
          </div>
          <div class="detail_row flex-between" style="border-top: 1px solid #eee;">
            <div class="detail_row">
              <label class="flex-shrink">备注：</label>
              <div class="line-break">{{orderDetail.orderRemarks}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 上传合同 -->
      <el-dialog title="查看合同"
                 :visible.sync="contractVisible"
                 width="30%"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :show-close="true"
                 class="order-detail-dialog">
        <el-upload ref="contractUpload"
                   :action="uploadURL"
                   accept=".jpg,.png,.docx,.doc,.pdf"
                   :file-list="contractList"
                   :on-preview="previewContractHandle"
                   :disabled="true">
          <!-- <el-button style="margin-left: 10px;"
                     size="small"
                     type="primary"
                     class="upload-button"
                     v-show="canUploadContrac">选择并上传</el-button> -->
        </el-upload>
      </el-dialog>
      <!-- 改价 -->
      <el-dialog
        title="再次改价"
        :visible.sync="priceChangeVisible"
        width="30%">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="请输入内容"
          :maxlength="200"
          v-model="priceChangeDataForm.leaveMsg">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button :loading="buttonLoading" @click="priceChangeVisible=false;priceChangeDataForm.leaveMsg='';">取 消</el-button>
          <el-button :loading="buttonLoading" type="primary" @click="confirmPriceChangeSubmitHandle">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils'
export default {
  data () {
    return {
      buttonLoading: false,
      orderDetail: null,
      // 合同模态框
      contractVisible: false,
      canUploadContrac: false, // 是否可上传合同
      contractList: [], // 合同列表
      uploadURL: 'aa',
      // 再次改价
      priceChangeVisible: false,
      priceChangeDataForm: {
        leaveMsg: '',
        orderId: ''
      },
      goodsPage: 1 // 商品分页
    }
  },
  computed: {
    orderId () {
      return this.$route.params.id
    }
  },
  watch: {
    orderId: {
      handler: 'getInfo',
      immediate: true
    }
  },
  methods: {
    // 查询订单详情
    getInfo () {
      if (!this.orderId) {
        return false
      }
      this.goodsPage = 1
      this.$request.get(`/front/consumer/order/orderInfo/${this.orderId}`)
        .then((res) => {
          this.orderDetail = res
        })
        .catch(() => {
          this.orderDetail = null
        })
    },
    // 去支付
    gotoPay () {
      this.$router.push({
        name: 'orderPay',
        query: {
          id: this.orderId,
          money: this.orderDetail.payMoney || '',
          virtualAccount: this.orderDetail.virtualAccount || ''
        }
      })
    },
    // 合同btn
    contract () {
      this.contractVisible = true
      if (this.orderDetail.contractUrls && this.orderDetail.contractUrls.length) {
        this.contractList = this.orderDetail.contractUrls.map(item => {
          return {
            url: item.url,
            name: item.fileName
          }
        })
      } else {
        this.contractList = []
      }
      // 合同同步完成无法上传，使用默认模板无法上传
      // if (!this.orderDetail.contractSyncBpm && this.orderDetail.contractType !== '20') {
      //   this.canUploadContrac = true // 可以上传
      //   this.contractList = this.orderDetail.contractUrls
      //   // this.contractDeleteList = []
      //   // this.contractDeleteListCancel = []
      //   // 重新获取合同list
      // } else {
      //   this.canUploadContrac = false
      //   this.contractList = this.orderDetail.contractUrls
      // }
    },
    // 预览下载合同
    previewContractHandle (item) {
      window.open(item.url)
    },
    // 取消订单
    cancelOrderHandle (row) {
      this.$confirm('是否取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataLoading = true
        this.$http.post(`/front/consumer/order/cancelOrder`, {
          orderId: this.orderId
        })
          .then(({ data: res }) => {
            this.dataLoading = false
            if (res.code === 0) {
              this.$message.success(res.message)
              this.getInfo()
            } else {
              return false
            }
          })
          .catch(() => {
            this.dataLoading = false
          })
      })
    },
    // bpm同步过来的订单 客户确认
    confirmOrderBPMHandle () {
      this.buttonLoading = true
      this.$http.post(`/front/consumer/order/confirmBpmOrderStatus/${this.orderId}`)
        .then(({ data: res }) => {
          this.buttonLoading = false
          if (res.code !== 0) {
            return false
          }
          this.getInfo()
        })
        .catch(() => {
          this.buttonLoading = false
        })
    },
    // 确认订单 确认改价
    confirmOrderHandle () {
      if (this.buttonLoading) {
        return
      }
      this.buttonLoading = true
      this.$http.post(`/front/consumer/order/confirmPrice`, {
        orderId: this.orderId
      })
        .then(({ data: res }) => {
          this.buttonLoading = false
          if (res.code !== 0) {
            return false
          }
          this.getInfo()
        })
        .catch(() => {
          this.buttonLoading = false
        })
    },
    // 再次改价
    confirmPriceChangeHandle (row) {
      this.priceChangeDataForm.leaveMsg = ''
      this.priceChangeDataForm.orderId = this.orderId
      this.priceChangeVisible = true
    },
    // 再次改价确认
    confirmPriceChangeSubmitHandle () {
      if (this.buttonLoading) {
        return
      }
      this.buttonLoading = true
      this.$http.post(`/front/consumer/order/confirmRejectPrice`, this.priceChangeDataForm)
        .then(({ data: res }) => {
          this.buttonLoading = false
          if (res.code !== 0) {
            return false
          }
          this.priceChangeVisible = false
          this.getDataList(1)
        })
        .catch(() => {
          this.buttonLoading = false
        })
    },
    // 跳转商品详情
    goodDetail (row) {
      openOther(`goodDetail?spuId=${row.goodsSpuId}&skuId=${row.goodsSkuId}`)
    },
    changeGoodsPage (page) {
      this.goodsPage = page
    }
  }
}
</script>
<style lang='scss' scoped>
.order_detail{
  background: #fff;
  padding: 30px;
  .detail_body{
    width: 907px;
    margin: 0 auto;
    .discount{
      text-decoration: line-through;
      color: #aaaaaa;
    }
    .detail_row{
      display: flex;
      margin-top: 20px;
      color: #666666;
      align-items: center;
      .item_col{
        margin-right: 30px;
      }
      .top_title{
        font-size: 20px;
        // margin-top: 40px;
        font-weight: 600;
        color: #333333;
      }
    }
    .flex-between{
      justify-content: space-between;
    }
  }
}
</style>
